// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__3tGRg","content":"Header_content__3z1OQ route-container"};